import { render, staticRenderFns } from "./PropagationMap.vue?vue&type=template&id=fc82c352&scoped=true"
import script from "./PropagationMap.vue?vue&type=script&lang=js"
export * from "./PropagationMap.vue?vue&type=script&lang=js"
import style0 from "./PropagationMap.vue?vue&type=style&index=0&id=fc82c352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc82c352",
  null
  
)

export default component.exports